import PropTypes from "prop-types"
import Icon from "components/planning_center_icon"
import { css } from "@emotion/core"
import { colors } from "components/shared/admin_colors"
import {
  ComboboxInput,
  ComboboxPopover,
  ComboboxList,
  ComboboxOption,
  useComboboxContext
} from "@reach/combobox"

const comboboxList = css`
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
`

const comboboxInputWrapper = css`
  background-color: white;
  border-radius: 3px;
  box-shadow: 0 0 0 1px ${colors.form_input_border_color};
  position: relative;
`
const comboboxInput = css`
  background-color: transparent;
  border: 0;
  box-shadow: none;
  margin-top: 0 !important;
  padding-right: 2rem;
`
const comboboxClearButton = css`
  align-items: center;
  bottom: 0;
  display: flex;
  padding: 0.5rem;
  position: absolute;
  right: 0;
  top: 0;
`
const comboboxIcon = css`
  font-size: 0.875rem;
  color: var(--color--neutral-400);
  line-height: 1;
`

const ComboBoxDropdown = ({
  items,
  value,
  itemKey,
  onChange,
  onClear,
  selectedItem = null,
  placeholder = "",
  disabled
}) => {
  const { isExpanded } = useComboboxContext()

  const handleClear = () => selectedItem && onClear()

  const renderItem = item => (item.render ? item.render(item) : item[itemKey])

  const iconSymbol = selectedItem
    ? "general#x"
    : isExpanded
    ? "general#up-caret"
    : "general#down-caret"

  const comboboxIconLabel = selectedItem
    ? "Clear selection"
    : isExpanded
    ? "Close selection list"
    : "Open selection list"

  return (
    <>
      <div css={comboboxInputWrapper}>
        <ComboboxInput
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          className="text-input"
          disabled={disabled}
          css={[{ cursor: disabled ? "not-allowed" : "auto" }, comboboxInput]}
        />
        <button
          onClick={handleClear}
          disabled={disabled}
          css={[
            { pointerEvents: isExpanded || selectedItem ? "all" : "none" },
            comboboxClearButton
          ]}
        >
          <Icon symbol={iconSymbol} css={comboboxIcon} arial-label={comboboxIconLabel} />
        </button>
      </div>
      <ComboboxPopover>
        <ComboboxList persistSelection css={comboboxList}>
          {items.length > 0 ? (
            items.map(item =>
              item.isDisabled ? (
                <div
                  key={item.key || item.id || item[itemKey]}
                  {...(item.isDisabled && { disabled: true })}
                  css={{
                    color: colors.neutral_500,
                    padding: "0.25rem 0.5rem"
                  }}
                >
                  {renderItem(item)}
                </div>
              ) : (
                <ComboboxOption key={item.key || item.id || item[itemKey]} value={item[itemKey]}>
                  {renderItem(item)}
                </ComboboxOption>
              )
            )
          ) : (
            <div
              css={{
                color: colors.neutral_500,
                padding: "0.25rem 0.5rem"
              }}
            >
              No Results
            </div>
          )}
        </ComboboxList>
      </ComboboxPopover>
    </>
  )
}

ComboBoxDropdown.propTypes = {
  items: PropTypes.array.isRequired,
  value: PropTypes.string.isRequired,
  itemKey: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  selectedItem: PropTypes.shape({}),
  placeholder: PropTypes.string
}

export default ComboBoxDropdown
